
export const estados ={
    Preafiliacion_Familiar: -1,
    Preafiliacion_Inicial: 0,
    Preafiliacion_NuevoOnline: 1,
    Preafiliacion_PresencialNuevo: 8,
    Preafiliacion_PresencialIngresada: 9, /* Haciendo preAfiliacion desde Ingreso Beneficiario */
    Preafiliacion_BandejaSeccional: 10,
    Preafiliacion_BandejaSeccionalModificada: 11,
    Preafiliacion_BandejaSeccionalObservada: 19,
    Preafiliacion_BandejaNacional: 20, /* Aunque primero Nacional la observe y luegos Seccional la derive devuelta a Nacional, tiene este estado que es el mismo que tienen las preafiliaciones que entran. */
    Preafiliacion_BandejaNacionalModificada: 21,
    Preafiliacion_BandejaNacionalObservada: 29, /* Esto es cuando una nacional la observan/rechazan */
    Preafiliacion_BandejaNacionalAprobada: 30

}